import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

import { isGroupcalApp } from './appType'
import { isInIframe } from './env'
import { isTrulyEmpty } from './object'

export function isUserLoggedIn() {
  return !!LocalStorage.get(LocalStorageKey.USER_ID)
}

export function isPreviewMode() {
  if (typeof window === 'undefined') return false

  const queryParams = new URLSearchParams(window.location.search)

  return (
    queryParams.get('preview') === '1' &&
    (isTrulyEmpty(LocalStorage.get(LocalStorageKey.USER_ID)) || isInIframe())
  )
}

export function isGuest() {
  return (
    isGroupcalApp() &&
    ((!LocalStorage.get(LocalStorageKey.PHONE_NUMBER) &&
      window.location.pathname.includes('/calendar')) ||
      isInIframe())
  )
}
